import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';

export interface CoverageCategoryTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

const categories = ['Tax', 'Fee', 'Surcharge', 'Premium', 'Reporting'];

const options = categories.map((category) => ({
  key: category,
  label: category,
  value: category,
}));

export const CoverageCategoryTypeaheadFilter = (componentProps: CoverageCategoryTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
